import { Grid, Typography,TextField,Button,Stack,Paper,Card,CardContent,CardHeader  } from '@mui/material';
const   MyCard = (props) => {
    const classes = {};
    return (
      <Card
        className={classes.root}
        variant="outlined"
      
        style={{ /*height: "100%",*/ marginTop:"8px"}}  {...props}
      >
        <CardHeader title={props.header}      color="textSecondary"   style={{ marginTop:"-5px" }}        className={classes.title}
          variant={props.variant ? props.variant : "h6"}  gutterBottom/>
        <CardContent>
     
        {/* <Typography
          className={classes.title}
          color="textSecondary"
          variant={props.variant ? props.variant : "h6"}
          gutterBottom
        >
         {props.header}
        </Typography> */}
         {props.children}
        </CardContent>
       
      </Card>
    );
  };
  export default MyCard;